import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { companyAnalysisQueryKeys } from "app/pages/sales-intelligence/modules/company-analysis/queries/queryKeyFactory";
import type { GeoBreakdown } from "app/pages/sales-intelligence/modules/company-analysis/types/geo-breakdown";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

interface IUseGeoBreakdownQueryOptions {
    enabled?: boolean;
}

export const useGeoBreakdownQuery = (
    domain: string,
    options?: IUseGeoBreakdownQueryOptions,
): UseQueryResult<GeoBreakdown[]> => {
    return useQuery({
        queryKey: companyAnalysisQueryKeys.geoBreakdown(domain),
        queryFn: async ({ signal }) => {
            return await salesApiService.companyAnalysis.fetchGeoBreakdown(domain, { cancellation: signal });
        },
        enabled: options?.enabled ?? true,
    });
};
